import { getLangCode, getLangData, useAppDispatch, useAppSelector } from "@hypexone/uicore";

type StateProps = {
  langSelected?: string;
  setLangSelected: any;
  onClose?: () => void;
};

const LanguagesList: React.FC<StateProps> = (props) => {
  const { langSelected, setLangSelected, onClose } = props;
  const { domainConfig } = useAppSelector((state) => state.common);
  const languages = domainConfig.languages || [];
  const dispatch = useAppDispatch();
  const currentLang =
    langSelected || sessionStorage.getItem("lang") || "en";

  const handleSelect = (language: string) => {
    const langCode = getLangCode(language)?.toLowerCase();
    if (!langCode) return;

    setLangSelected?.(langCode);
    sessionStorage.setItem("lang", langCode);
    dispatch(getLangData(langCode));
    onClose?.();
  };

  return (
    <div className="flex flex-col gap-1 py-2">
      {languages.map((language) => {
        const langCode = getLangCode(language)?.toLowerCase();
        const isSelected = currentLang === langCode;

        return (
          <div
            key={language}
            className={`text-sm px-2 cursor-pointer hover:underline ${
              isSelected ? "font-semibold text-[#2789ce]" : "text-black"
            }`}
            onClick={() => handleSelect(language)}
          >
            {language}
          </div>
        );
      })}
    </div>
  );
};

export default LanguagesList;
